import {addEvent} from '../add-event'
import {getRatingStars} from '../helpers/compliance-rating-helper'

export function selectComplianceRatingEvent(fromRating: number, toRating: number): boolean {
    return addEvent('reportsPageSelectComplianceRating', {
        fromStars: getRatingStars(fromRating),
        toStars: getRatingStars(toRating),
    })
}
